import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiButton from '@mui/material/Button';
import { track, Events } from 'src/utils/analytics';

const SHADOW = '4px 4px 0px rgba(255,255,255,0.3)';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: '#2C2C2C',
        borderTop: '2px solid #1e1e1e',
        py: { xs: 8, md: 12 },
        px: { xs: 3, md: 6 },
        textAlign: 'center',
      }}
    >
      <Box sx={{ maxWidth: 700, mx: 'auto' }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Montserrat, Inter, sans-serif',
            fontSize: { xs: '1.75rem', md: '2.5rem' },
            fontWeight: 800,
            color: '#FFFFFF',
            mb: 2,
          }}
        >
          Ready to Transform Writing in Your School?
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Lato, Inter, sans-serif',
            fontSize: { xs: '1rem', md: '1.15rem' },
            color: 'rgba(255,255,255,0.7)',
            lineHeight: 1.7,
            mb: 5,
          }}
        >
          Join 100+ school districts already using Pressto to empower student writers and journalists.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <MuiButton
            variant="contained"
            onClick={() => { track(Events.ClickedCTA, { location: 'bottom_cta', label: 'Get Started Free', destination: '/register' }); navigate('/register'); }}
            sx={{
              backgroundColor: '#FFE082',
              color: '#2C2C2C',
              fontFamily: 'Montserrat, Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1rem',
              textTransform: 'none',
              borderRadius: '6px',
              border: '2px solid #1e1e1e',
              boxShadow: SHADOW,
              px: 5,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#FFD54F',
                boxShadow: '2px 2px 0px rgba(255,255,255,0.3)',
                transform: 'translate(2px, 2px)',
              },
              transition: 'all 100ms ease-in-out',
            }}
          >
            Get Started Free
          </MuiButton>
          <MuiButton
            variant="outlined"
            onClick={() => { track(Events.ClickedCTA, { location: 'bottom_cta', label: 'Contact Sales', destination: '/contact' }); navigate('/contact'); }}
            sx={{
              borderColor: '#FFFFFF',
              border: '2px solid #FFFFFF',
              color: '#FFFFFF',
              fontFamily: 'Montserrat, Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1rem',
              textTransform: 'none',
              borderRadius: '6px',
              boxShadow: SHADOW,
              px: 5,
              py: 1.5,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: '#FFFFFF',
                boxShadow: '2px 2px 0px rgba(255,255,255,0.3)',
                transform: 'translate(2px, 2px)',
              },
              transition: 'all 100ms ease-in-out',
            }}
          >
            Contact Sales
          </MuiButton>
        </Box>
      </Box>
    </Box>
  );
}
